import BootstrapTooltip from "@/react/bootstrap/components/BootstrapTooltip";
import UiInput from "@/react/story/components/ui/UiInput";
import UiLoader from "@/react/story/components/ui/UiLoader";
import { DEFAULTS } from "@/react/story/data";
import { useConfig } from "@/react/story/providers/ConfigContext";
import { useStory } from "@/react/story/providers/StoryContext";
import { useIsFetching } from "@tanstack/react-query";

export default function NavHeader() {
    const Config = useConfig();
    const Story = useStory();

    const IsFetching = useIsFetching();

    return (
        <div>
            <div className="d-flex align-items-center gap-3 mb-3">
                <h2 className="mb-0 me-auto">Format</h2>
                <BootstrapTooltip title={Config.isFullscreen ? "Quitter le plein écran" : "Plein écran"}>
                    <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => Config.toggleFullscreen()}>
                        {IsFetching ? (
                            <UiLoader />
                        ) : (
                            <span className={`bi-${Config.isFullscreen ? "fullscreen-exit" : "arrows-fullscreen"}`}></span>
                        )}
                    </button>
                </BootstrapTooltip>
            </div>
            <div className="d-flex justify-content-between align-items-center gap-3 mb-3">
                <UiInput
                    type="number"
                    defaultValue={Story.story.config.width}
                    onChange={width => void Story.patch("config.width", width ?? DEFAULTS.STORY.width)}
                />
                <span>x</span>
                <UiInput
                    type="number"
                    defaultValue={Story.story.config.height}
                    onChange={height => void Story.patch("config.height", height ?? DEFAULTS.STORY.height)}
                />
            </div>
        </div>
    );
}
